<form
  [formGroup]='formGroup'
  class='widget'
>
  <div class='form-group'>
    <pt-input-label
      *ngIf='label'
      [fontWeightBold]='fontWeightBold'
      [inputId]='inputId'
      [isRequired]='isRequired'
      [label]='label'
      style='display: contents'
    ></pt-input-label>
    <div class='form-check mb-2' style="
        height: 21px;
        max-height: 21px;
        min-height: 21px;
    ">
      <input
        formControlName="autoGenerate"
        class='form-check-input'
        id='defaultInternalId'
        name='internalId'
        type='checkbox'
      >
      <label class='form-check-label' for='defaultInternalId'>
        {{ checkboxLabel }}
      </label>
    </div>

    <input
      [class.is-invalid]='isChanged && formGroup.invalid'
      [id]='inputId'
      aria-describedby='ptWInputHelp'
      autocomplete='off'
      class='form-control form-control-sm'
      formControlName='value'
      placeholder='{{placeholder}}'
      type='text'
    >
    <small [innerHTML]='help'
           class='form-text text-muted' id='ptWInputHelp_{{controlName}}'>
    </small>
  </div>
</form>
